import { MeddreamOverview } from "./MeddreamOverview";
import { ImagingOverview } from "../sources/imaging/ImagingOverview";
import { LaboratoryOverview } from "../sources/laboratory/LaboratoryOverview";
import { NotificationsOverview } from "../sources/notifications/NotificationsOverview";
import { PatientsOverview } from "../sources/patients/PatientsOverview";
import { UsersOverview } from "../sources/users/UsersOverview";

/**
 * Hub overview multi-dominio del día.
 */
export function DashboardHub(): React.JSX.Element {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Métricas
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Resumen del día · overview operativo
        </p>
      </div>

      <MeddreamOverview />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <ImagingOverview />
        <LaboratoryOverview />
      </div>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <UsersOverview />
        <NotificationsOverview />
      </div>

      <PatientsOverview />
    </div>
  );
}
